import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import { showSnack } from './snackbarActions';
export var TRANSFER_REQUESTS_RECEIVED_REQUESTED = 'TRANSFER_REQUESTS_RECEIVED_REQUESTED';
export var TRANSFER_REQUESTS_RECEIVED_RECEIVED = 'TRANSFER_REQUESTS_RECEIVED_RECEIVED';
export var TRANSFER_REQUESTS_REQUESTED_REQUESTED = 'TRANSFER_REQUESTS_REQUESTED_REQUESTED';
export var TRANSFER_REQUESTS_REQUESTED_RECEIVED = 'TRANSFER_REQUESTS_REQUESTED_RECEIVED';
export var TRANSFER_REQUEST_CONFIRMATION_SENT = 'TRANSFER_REQUEST_CONFIRMATION_SENT';
export var TRANSFER_REQUEST_CONFIRMATION_SUCCESS = 'TRANSFER_REQUEST_CONFIRMATION_SUCCESS';
export var TRANSFER_REQUEST_CONFIRMATION_FAILED = 'TRANSFER_REQUEST_CONFIRMATION_FAILED';

// this.context.t('Transfer Approved');
var approveSnackText = 'Transfer Approved';
// this.context.t('Transfer Rejected');
var rejectSnackText = 'Transfer Rejected';
export var getTransferRequestsReceived = function getTransferRequestsReceived(PayerAccountId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var OMSId, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(transferRequestsReceivedRequested());
              OMSId = getState().user.userInfo.OMSId;
              _context.next = 4;
              return dispatch(callAPI('GetRequestTransferRequestsReceived', {
                PayerAccountId: PayerAccountId,
                OMSId: OMSId
              }));
            case 4:
              response = _context.sent;
              dispatch(transferRequestsReceivedReceived(response));
            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getTransferRequestsRequested = function getTransferRequestsRequested(RequestorAccountId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var OMSId, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(transferRequestsRequestedRequested());
              OMSId = getState().user.userInfo.OMSId;
              _context2.next = 4;
              return dispatch(callAPI('GetRequestTransferRequestsRequested', {
                RequestorAccountId: RequestorAccountId,
                OMSId: OMSId,
                OperatorId: 1
              }));
            case 4:
              response = _context2.sent;
              dispatch(transferRequestsRequestedReceived(response));
            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var approveTransferRequest = function approveTransferRequest(requestCode) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var response, approved;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(transferRequestConfirmationSent(requestCode));
              _context3.next = 3;
              return dispatch(callAPI('ConfirmRequestTransferFunds', {
                OMSId: 1,
                OperatorId: 1,
                requestCode: requestCode
              }));
            case 3:
              response = _context3.sent;
              approved = true;
              handleResponse(response, requestCode, approved, dispatch, getState);
            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var rejectTransferRequest = function rejectTransferRequest(requestCode) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var response, approved;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch(transferRequestConfirmationSent(requestCode));
              _context4.next = 3;
              return dispatch(callAPI('RejectRequestTransferFunds', {
                OMSId: 1,
                OperatorId: 1,
                requestCode: requestCode
              }));
            case 3:
              response = _context4.sent;
              approved = false;
              handleResponse(response, requestCode, approved, dispatch, getState);
            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var handleResponse = function handleResponse(response, requestCode, approved, dispatch, getState) {
  if (response.result) {
    dispatch(transferRequestConfirmationSuccess(response));
    var snackbarPayload = {
      id: 'confirmTransferRequestSuccess',
      text: approved ? approveSnackText : rejectSnackText,
      type: 'success'
    };
    dispatch(showSnack(snackbarPayload));
    var accountId = getState().user.selectedAccountId;
    dispatch(getTransferRequestsReceived(accountId, 1));
  } else {
    dispatch(transferRequestConfirmationFailed(requestCode));
    var _snackbarPayload = {
      id: 'confirmTransferRequestFailed',
      // this.context.t('Failed to confirm transfer request');
      text: (response.detail ? response.detail : 'Failed to confirm transfer request') + '!',
      type: 'warning'
    };
    dispatch(showSnack(_snackbarPayload));
  }
};
export var transferRequestsReceivedRequested = function transferRequestsReceivedRequested() {
  return {
    type: TRANSFER_REQUESTS_RECEIVED_REQUESTED
  };
};
export var transferRequestsReceivedReceived = function transferRequestsReceivedReceived(payload) {
  return {
    type: TRANSFER_REQUESTS_RECEIVED_RECEIVED,
    payload: payload
  };
};
export var transferRequestsRequestedRequested = function transferRequestsRequestedRequested() {
  return {
    type: TRANSFER_REQUESTS_REQUESTED_REQUESTED
  };
};
export var transferRequestsRequestedReceived = function transferRequestsRequestedReceived(payload) {
  return {
    type: TRANSFER_REQUESTS_REQUESTED_RECEIVED,
    payload: payload
  };
};
export var transferRequestConfirmationSent = function transferRequestConfirmationSent(payload) {
  return {
    type: TRANSFER_REQUEST_CONFIRMATION_SENT,
    payload: payload
  };
};
export var transferRequestConfirmationSuccess = function transferRequestConfirmationSuccess(payload) {
  return {
    type: TRANSFER_REQUEST_CONFIRMATION_SUCCESS,
    payload: payload
  };
};
export var transferRequestConfirmationFailed = function transferRequestConfirmationFailed(payload) {
  return {
    type: TRANSFER_REQUEST_CONFIRMATION_FAILED,
    payload: payload
  };
};